(function($) {

    'use strict';

    function Slider() {

        var self = this,
            $el = null,
            $slider = $('.js-slider'),
            options = {
                'example': null
            };

        /**
         * Generic resize
         */
        /*function onResize() {
          if (window.bp.getValue() === 'lg' || window.bp.getValue() === 'xl') {
            Utils.setEqualHeight($summaryNews);
          } else {
            Utils.removeEqualHeight($summaryNews);
          }
        }*/

        /**
         * Public constructor
         * @param  {Object} opts Options
         */
        self.initialize = function(opts) {
        //extends options
        for (var i in opts) { options[i] = opts[i];}

        // Caching

        if($slider.length) {
            $slider.addClass('owl-carousel');
            $slider.owlCarousel({
                items: 1,
                loop: true,
                nav: true,
                dots: false,
                navText: ["", ""],
                center : true,
                lazyLoad: true,
                autoplay: true,
                autoplayHoverPause: true,
                autoplaySpeed: 1000,
                smartSpeed: 1000 
            });
        }
    };

        self.initialize.apply(self, arguments);
        return self;
    }

    /* Namespace declaration */
    window.Slider = Slider;

}(jQuery));
